define('glu/grid/filter/gridFuzzySearch',['require','./fieldSearch'],function(require) {
    'use strict';

    var FieldSearch = require('./fieldSearch');

    return FieldSearch.extend({
        className: 'grid-fuzzy',
        filter: function(field, value, model) {
            try {
                var regex = new RegExp('.*(' + value + ').*', 'i');
            } catch (e) {
                return false;
            }

            // REVIEW: Use util instead
            for (var key in model.attributes) {
                if (!model.attributes.hasOwnProperty(key)) {
                    return;
                }
                var val = model.attributes[key];
                if (val.search && val.search(regex) > -1) {
                    return true;
                }
            }
            return false;
        }
    });
});

